const styles = ({ BREAKPOINTS }) => ({
  container: {
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
    padding: '30px 0 0',
    backgroundColor: '#fff',
    margin: '0 0 30px',
    position: 'relative',
    height: '140px',
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      padding: '48px 0 0'
    }
  }
})

export default styles
